import { createElement, lazy } from 'react'

import { routes } from '../routes'
import { registerRoute } from '../utils/routeRegistry'

const ModuleWrapper = lazy(() => import('./containers/ModuleWrapper'))

const initRoute = () => {
    registerRoute({
        path: routes.HOME + '/*',
        element: createElement(ModuleWrapper, { moduleUrl: routes.HOME_MODULE }),
    })
    registerRoute({
        path: routes.EXPERT + '/*',
        element: createElement(ModuleWrapper, { moduleUrl: routes.EXPERT_MODULE }),
    })
    registerRoute({
        path: routes.SALES + '/*',
        element: createElement(ModuleWrapper, { moduleUrl: routes.SALES_MODULE }),
    })
}

export default initRoute
